import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form';
import { Radio } from 'antd';
import InputField from '../../../../helpers/Fields/InputField';
import { required, length } from 'redux-form-validators';
import { createQuiz, addQuestionQiuz } from '../../actions';
import {toastr} from 'react-redux-toastr'
import SelectFieldQuiz from './SelectField';
import './style.scss';
import { updateQuestionStatus } from '../../../QbmPresentation/actions';

class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      type: 'create',
      statusQuestion: 3,
    }
  }
  

  submit = async (values) => {
    try {
      const {formatMessage} = this.context;
      const { handleClose, selectedQuestionIds } = this.props;

      if(!selectedQuestionIds || !Array.isArray(selectedQuestionIds) || !selectedQuestionIds.length) {
        return;
      }

      const { type, statusQuestion } = this.state;
      if(type == 'create') {
        const quiz = await createQuiz({title: values.title});
        await addQuestionQiuz(quiz.id, selectedQuestionIds);
        toastr.success(formatMessage('msgNotificationQuiz'), formatMessage('msgNotificationQuizCreated'))
      } else {
        const data = await addQuestionQiuz(values.quiz_id, selectedQuestionIds);
        if(data.isDuplicate){
          toastr.warning(formatMessage('msgNotificationQuizDuplicte'), formatMessage('msgNotificationQuizDuplicte'))
        } else {
          toastr.success(formatMessage('msgNotificationQuiz'), formatMessage('msgNotificationQuizUpdate'))
        }
        
      }
      
      await updateQuestionStatus({data: JSON.stringify({selectedQuestionIds , statusQuestion}) })
      this.props.checkAndUploadQuestions();
      this.props.checkAndUploadGeneralStatistic(true);
      handleClose();
     
    } catch (error) {
      
    }
  }

  onChange

  render() {
    const {formatMessage} = this.context;
    const { handleSubmit, handleClose, selectedQuestionIds } = this.props;
    const { type, statusQuestion } = this.state;
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };

    return (
      <form className="create-dialog-form form-quiz-create" onSubmit={handleSubmit(this.submit)}>
        <div className="row">
          {!selectedQuestionIds || !Array.isArray(selectedQuestionIds) || !selectedQuestionIds.length ? <div style={{color: 'red', textAlign: 'center'}}>{formatMessage('errrMessageNotSelectedQuestionAddQiuz')}</div> : null}
        <Radio.Group onChange={(e) => {
          this.setState({ type: e.target.value });
        }} value={this.state.type}>
          <Radio style={radioStyle} value={'create'}>
            {formatMessage('optionTitleCerateNewQuiz')}
          </Radio>
          <div style={{marginLeft: 24}}>
            <Field 
              name='title'
              component={InputField}
              validate={type == 'update' ? [] : [required(), length({ max: 65 })]}
              disabled={type == 'update'}
            />
          </div>
          <Radio style={radioStyle} value={'update'}>
            {formatMessage('optionTitleAddToExistinqQuiz')}
          </Radio>
          <div style={{marginLeft: 24}}>
            <Field 
              name='quiz_id'
              component={SelectFieldQuiz}
              validate={type == 'create' ? [] : [required()]}
              disabled={type == 'create'}
            />
          </div>
          
        </Radio.Group>
        </div>
        <div className="radio-button-grout-status">
            <label>
                <input type="radio" onChange={() => {this.setState({statusQuestion: 3})}} checked={statusQuestion == 3}/>
                <div style={{marginLeft: 7}} className="item used">Used</div>
            </label>
            <label>
                <input type="radio" onChange={() => {this.setState({statusQuestion: 1})}} checked={statusQuestion == 1}/>
                <div style={{marginLeft: 7}} className="item read">Ready to use</div>
            </label>
            <label>
                <input type="radio"onChange={() => {this.setState({statusQuestion: 2})}} checked={statusQuestion == 2}/>
                <div style={{marginLeft: 7}} className="item unused">Unused</div>
            </label>
        </div>
        <div className="create-dialog-form__group flex"  style={{marginTop: 10}}>
          <button className="btn btn-warning" type="button" onClick={() => {
            handleClose();
          }}>{formatMessage('btnModalCancel')}</button>
          <button className="btn btn-primary" type="submit">{formatMessage('btnModalCreateQuiz')}</button>
        </div>
      </form>
    );
  }
}

FormContent = reduxForm({
  form: 'form_quiz',
  enableReinitialize: true,
})(FormContent);

export default FormContent;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmQuiz/components/FormContent/index.js